import React from 'react'

import styled, { css } from 'styled-components'

import PriceIcon from 'src/Assets/Svg/common/Price.svg?react'
import {
  PrimaryRadioWithOverlay,
  PrimaryRadioWithOverlayProps,
} from 'src/Components/PrimaryRadioWithOverlay/RadioInput'
import { SimpleLabel } from 'src/Components/SimpleLabel'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
  width: 100%;
  min-height: 48px;

  &:active {
    svg {
      path {
        fill: ${({ theme }) => theme.color.slateGrey};
      }
    }
  }
`
const Headline = styled.div`
  display: flex;
  min-height: 24px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`
const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  flex: 1 0 0;
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  display: flex;
  align-items: center;
  gap: 4px;

  ${({ theme }) => css`
    ${Container}:active & {
      color: ${theme.color.slateGrey};
    }
  `}
`
const Subtitle = styled(Title)`
  font-weight: 400;
  ${({ theme }) => css`
    ${Container}:active & {
      color: ${theme.color.slateGrey};
    }
  `}
`

type Props = Pick<
  PrimaryRadioWithOverlayProps,
  'checked' | 'disabled' | 'onChange' | 'id' | 'name' | 'children'
> & {
  title: string
  subTitle: string
  priceIconCount: number
  isRecommended?: boolean
}
export const CountryOption: React.FC<Props> = (props) => {
  const { title, subTitle, children, priceIconCount, isRecommended, ...rest } =
    props

  const array = Array.from({ length: priceIconCount }, (_, i) => i + 1)
  return (
    <PrimaryRadioWithOverlay
      label={
        <Container>
          <Headline>
            <Title>
              <div>{title}</div>
              {isRecommended && (
                <SimpleLabel color={'green'}>Recommended</SimpleLabel>
              )}
            </Title>
            {array.map((i) => (
              <PriceIcon key={i} />
            ))}
          </Headline>
          {subTitle && <Subtitle>{subTitle}</Subtitle>}
        </Container>
      }
      {...rest}
    >
      {children}
    </PrimaryRadioWithOverlay>
  )
}
